import { useTranslation } from 'react-i18next';

const ANNOUNCEMENT_TEXT_KEY = 'announcement.text';

export function Announcement() {
	const { t } = useTranslation();

	const announcementText = t(ANNOUNCEMENT_TEXT_KEY);
	const hasAnnouncement = announcementText !== ANNOUNCEMENT_TEXT_KEY;

	return (
		<>
			{hasAnnouncement && (
				<div style={{ backgroundColor: 'lightyellow', padding: '13px' }}>{announcementText}</div>
			)}
		</>
	);
}
